import ContactRedirectPage from './ContactRedirectPage';

export default ContactRedirectPage;
